import React, { FC } from 'react';
import { TextButton } from '../../../commons/buttons/TextButton';
import { GoogleIcon } from '../../../commons/icons/Google';

interface LoginWithGoogleProps {
  onSuccess: () => void;
}

export const LoginWithGoogle: FC<LoginWithGoogleProps> = ({ onSuccess }) => {
  return (
    <TextButton label={<GoogleIcon className="login-socials__item" />} handleClick={onSuccess} className="unstyled" />
  );
};
